import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Company,BaseSearchingCriteria } from '@app/models/customer/company';


@Injectable()
export class CompanyService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: BaseSearchingCriteria, page: number = 0,
     size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Company>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new BaseSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        params = params.set('locale', this.commonService.getDefaultLang());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/company`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <Company[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(company: Company): Observable<Company> {

        let body = JSON.stringify(company);

        return this.httpClient.post(`${environment.API_END_POINT}/company`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Company[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string): Observable<Company> {
        return this.httpClient.get(`${environment.API_END_POINT}/company/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return <Company>((<any>response).content);
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    // getSimpleCompany(id: string): Observable<Company> {
    //     return this.httpClient.get(`${environment.API_END_POINT}/company/simple/${id}`, { headers: this.commonService.getHeaders() })
    //         .pipe(
    //             map(response =>  {
    //                 return <Company>((<any>response).content);
    //             }),
    //             catchError((error: Response | any) => this.commonService.handleHttpError(error))
    //         );
    // }

    update(company: Company): Observable<Company> {

        let body = JSON.stringify(company);

        return this.httpClient.put(`${environment.API_END_POINT}/company/${company.companyId}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Company>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    loadAll(): Observable<Company[]> {
        return this.httpClient.get(`${environment.API_END_POINT}/company/all`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return <Company[]>((<any>response).content);
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    loadAllSimple(): Observable<Company[]> {
        return this.httpClient.get(`${environment.API_END_POINT}/company/all/simple`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return <Company[]>((<any>response).content);
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    loadSimple(id: string): Observable<Company> {
        return this.httpClient.get(`${environment.API_END_POINT}/company/simple/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return <Company>((<any>response).content);
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

}